import { BaseSearch } from '@/services/_base/BaseSearch'
import type { Tenant } from '@/types/Tenant'
import type { IFirestoreService } from '@/platform/firebase/firestore'

export class TenantSearch extends BaseSearch<Tenant> {
  constructor(session: { tenantId?: string; userId?: string }, firestore: IFirestoreService) {
    super('tenants', session, 'tenant.search', firestore)
  }

  bySlug(slug: string) {
    this.where('slug', '==', slug)
    this.appendToMetaName('bySlug')
    return this
  }

  byAuthTenantId(authTenantId: string) {
    this.where('auth.tenantId', '==', authTenantId)
    this.appendToMetaName('byAuthTenantId')
    return this
  }

  byEmailDomain(emailDomain: string) {
    this.where('emailDomains', 'array-contains', emailDomain)
    this.appendToMetaName('byEmailDomain')
    return this
  }

  bySubscriptionTier(tier: string) {
    this.where('subscriptionTier', '==', tier)
    this.appendToMetaName('bySubscriptionTier')
    return this
  }

  recentlyCreated(limit = 50) {
    this.orderBy('createdAt', 'desc').limit(limit)
    this.appendToMetaName('recentlyCreated')
    return this
  }
}
